import { Fire, MoneyBillTransfer } from '@unified-checkout/design-system/icons/index';

import type { ICategoryCardProps } from '@app/dashboard/types/innerLayout/bills/category-card';

import styles from './category-card.module.scss';

export const CategoryCard = ({ category, onClickHandler }: ICategoryCardProps) => (
  <div className={styles['category-card']} onClick={() => onClickHandler(category)}>
    {category.cashback && (
      <div className={styles['category-card__cashback']}>
        {Fire} {category.cashback}
      </div>
    )}
    {
      category.category_icon ?
        <img
          className={styles['category-card__icon']}
          src={category.category_icon}
          alt={category.category_title}
        />
        :
        <div className={styles['category-card__icon']}>
          {MoneyBillTransfer}
        </div>
    }
    <div className={styles['category-card__title']}>
      {category.category_title}
    </div>
  </div>
);
